module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With Material Design Icons")]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify",
      "icon-clickable": ""
    },
    on: {
      "icon-click": _vm.searchIconClick
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "icon": "email"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Credit card",
      "icon": "credit-card"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With FontAwesome")]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon-pack": "fas",
      "icon": "search"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "icon-pack": "fas",
      "icon": "envelope"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Credit card",
      "icon-pack": "far",
      "icon": "credit-card"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c12ac90"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/examples/ExIcons.vue
// module id = 1100
// module chunks = 13 127